/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import { Grid, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DashboardSummary } from '../orders/models/dashboard-stats.type'
import { formatCurrency, formatInt } from './dashboard-helpers'

const styles = {
    paper: css`
        padding: 16px;
        height: 100%;
    `,
    label: css`
        color: rgba(0, 0, 0, 0.6);
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.4px;
    `,
    value: css`
        font-size: 26px;
        font-weight: 600;
        margin-top: 4px;
        white-space: nowrap;
    `,
}

type Props = {
    summary?: DashboardSummary
}

export const DashboardSummaryCards: React.FC<Props> = ({ summary }) => {
    const { t } = useTranslation()
    const cards = [
        { label: t('TEXT_TOTAL_ORDERS', 'Bestillinger'), value: formatInt(summary?.totalOrders ?? 0) },
        { label: t('TEXT_TOTAL_REPORTS', 'Rapporter levert'), value: formatInt(summary?.totalItems ?? 0) },
        { label: t('TEXT_TOTAL_REVENUE', 'Omsetning'), value: formatCurrency(summary?.totalRevenue ?? 0) },
        { label: t('TEXT_ACTIVE_REALTORS', 'Aktive meglere'), value: formatInt(summary?.activeRealtors ?? 0) },
        { label: t('TEXT_ACTIVE_COMPANIES', 'Aktive kontorer'), value: formatInt(summary?.activeCompanies ?? 0) },
    ]

    return (
        <Grid container spacing={2}>
            {cards.map((card) => (
                <Grid item xs={12} sm={6} md={true} key={card.label}>
                    <Paper elevation={0} css={styles.paper}>
                        <div css={styles.label}>{card.label}</div>
                        <div css={styles.value}>{card.value}</div>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    )
}
